<style lang="less">
// TODO: Let's figure out a less weird way to do this.
@import (reference) '../../less/modules/legacy';
@import '../../less/component-wysiwyg';

.wysiwyg-input-container {
  border: 1px solid rgb(214, 214, 214);
}

.redactor-toolbar {
  z-index: auto; /* The lib defines this as 100, there doesn't seem to be any reason why though. */
}
.wysiwygValue {
  padding: 10px;
}
</style>

<template>
  <div class="wysiwyg-input-container">
    <div class="wysiwygValue" ref="textarea" v-html="initialValue"></div>
  </div>
</template>

<script>
const jQuery = require('jquery');
const wysiwyg = jQuery;
window.jQuery = jQuery;
window.wysiwyg = jQuery;

require('../../../public/assets/js/vendor/redactor/redactor.js');
require('../../../public/assets/js/vendor/redactor/redactor.css');

wysiwyg.Redactor.prototype.clearFormatting = function () {
  return {
    init: function () {
      var button = this.button.add('clearFormatting', 'Clear formatting');
      this.button.setIcon(button, '<i class="icon-eraser"></i>');
      this.button.addCallback(button, this.clearFormatting.clearFormatting);
    },

    clearFormatting: function () {
      this.block.format('p');
      this.block.removeAllClass();
      this.block.removeAllAttr();
      this.link.unlink();
      this.inline.removeFormat();
      this.inline.removeAllClass();
      this.inline.removeAllAttr();
    },
  };
};

const BUTTON_CONFIGS = {
  default: {
    plugins: ['clearFormatting'],
    buttons: ['bold', 'italic', 'ul', 'ol', 'link'],
  },

  advanced: {
    plugins: ['source', 'alignment', 'clearFormatting'],
    buttons: ['format', 'bold', 'html', 'alignment', 'italic', 'ul', 'ol', 'link'],
    formatting: ['p', 'h2', 'blockquote'],
  },
};

function normalizeLineEndings(string) {
  return string ? string.replace(/[\n\r]+/g, '\n') : null;
}

module.exports = {
  props: {
    value: String,
    advanced: Boolean,
    floating: Boolean,
    placeholder: String,
    autofocus: {
      type: Boolean,
      default: false,
    },
    toolbar: {
      type: Boolean,
      default: true,
    },
    inline: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      initialValue: this.value,
    };
  },

  mounted() {
    const componentInstance = this;
    const buttonConfig = this.advanced ? BUTTON_CONFIGS.advanced : BUTTON_CONFIGS.default;

    $(this.$refs.textarea).redactor(
      Object.assign(
        {
          air: this.floating,
          focus: this.autofocus,
          placeholder: this.placeholder,
          toolbar: this.toolbar,
          inline: this.inline,
        },
        buttonConfig,
        {
          callbacks: {
            change() {
              componentInstance.handleChange(this);
            },

            blur() {
              componentInstance.handleChange(this);
            },
          },
        },
      ),
    );
  },

  methods: {
    handleChange(redactorInstance) {
      const redactorValue = redactorInstance.code.get();
      if (normalizeLineEndings(redactorValue) !== normalizeLineEndings(this.value || '')) {
        this.$emit('input', redactorValue);
      }
    },
  },

  watch: {
    value(value) {
      const currentValue = $(this.$refs.textarea).redactor('code.get');
      if (value !== currentValue) {
        $(this.$refs.textarea).redactor('code.set', value);
      }
    },
  },

  beforeDestroy() {
    $(this.$refs.textarea).redactor('core.destroy');
  },
};
</script>
